import { render, staticRenderFns } from "./SingleOptionDropdown.vue?vue&type=template&id=050c3913&scoped=true"
import script from "./SingleOptionDropdown.vue?vue&type=script&lang=js"
export * from "./SingleOptionDropdown.vue?vue&type=script&lang=js"
import style0 from "./SingleOptionDropdown.vue?vue&type=style&index=0&id=050c3913&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "050c3913",
  null
  
)

export default component.exports